import { Link } from 'react-router-dom'
import { useAuth } from '@/auth/useAuth'
import { GLOBAL_ROLE_LABELS, SPACE_ROLE_LABELS } from '@/auth/permissions'
import { Badge, Card, EmptyState, KeyValue, Scramble } from '@/components/ui'
import './dashboard.css'

/**
 * Startseite nach dem Login.
 *
 * Die Bühne mit dem 4NE-1 steckt in der Shell und läuft hinter jeder Seite —
 * hier gibt es deshalb keine Bühnen-Kachel mehr, sondern nur die Inhalte, die
 * darüber schweben.
 */
export function Dashboard() {
  const { profile, globalRole, permissions, spaces } = useAuth()

  const firstName = profile?.full_name?.split(' ')[0] ?? null

  return (
    <div className="stack-lg">
      <header className="dashboard__hero">
        <p className="eyebrow eyebrow-accent">
          <Scramble text="4NE-1 · Humanoid Platform" speed={34} />
        </p>
        {/* Die Uberschrift pegelt sich ein wie eine Anzeige. Der Schluessel
            ist der Versatz: Overline zuerst, Zeile danach — gleichzeitig
            gestartet lesen sich beide als Stoerung statt als Aufbau. */}
        <Scramble
          as="h1"
          className="display"
          delay={220}
          speed={22}
          text={firstName ? `Willkommen zurück, ${firstName}.` : 'NEURA Performance'}
        />
        <p className="dashboard__lead">
          Internes Performance-Intranet. Was Sie hier sehen, hängt an Ihrer
          Bereichszugehörigkeit — nicht an Ihrem Rang.
        </p>
      </header>

      <div className="dashboard__grid">
        <Card title="Ihr Zugang">
          <KeyValue
            items={[
              { label: 'Name', value: profile?.full_name ?? '—' },
              { label: 'E-Mail', value: profile?.email ?? '—', mono: true },
              { label: 'Abteilung', value: profile?.department ?? '—' },
              {
                label: 'Globale Rolle',
                value: globalRole ? (
                  <Badge tone="accent">{GLOBAL_ROLE_LABELS[globalRole]}</Badge>
                ) : (
                  '—'
                ),
              },
              {
                label: 'Globale Rechte',
                value: <span className="numeric">{permissions.size}</span>,
              },
            ]}
          />
        </Card>

        <Card title="Meine Bereiche" flush={spaces.length > 0}>
          {spaces.length === 0 ? (
            <EmptyState
              title="Noch keinem Bereich zugeordnet"
              description="Inhalte werden über die Bereichszugehörigkeit freigegeben. Eine Bereichsleitung kann Sie hinzufügen."
            />
          ) : (
            <ul className="dashboard__spaces">
              {spaces.map((space) => (
                <li key={space.id}>
                  <Link className="dashboard__space" to={`/spaces/${space.slug}`}>
                    <span className="dashboard__space-name">{space.name}</span>
                    <span className="dashboard__space-meta">
                      <Badge tone="neutral" outline>
                        {SPACE_ROLE_LABELS[space.role]}
                      </Badge>
                      <span className="numeric dashboard__space-count">
                        {space.permissions.length} Rechte
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </Card>
      </div>
    </div>
  )
}
